import * as React from 'react'
import { View, Text, TouchableOpacity } from 'react-native'
import styled from '@theme/styled-components'

import Icon from '@components/icon/Icons'

import theme from '@theme/Theme'

interface Props {
  left: ButtonIcon
  title: string
  right: {
    label: string
    onClick: () => void
  }
}

const ModalHeader = ({ left, title, right }: Props) => {
  return (
    <Header>
      <IconContainer onPress={left.onClick}>
        <Icon name={left.name} size={25} color={theme.colors.primary} />
      </IconContainer>
      <Title>{title}</Title>
      <Reset onPress={right.onClick}>{right.label}</Reset>
    </Header>
  )
}

const Header = styled(View)`
  flex-direction: row;
  justify-content: space-between;
  margin-top: -20px;
  margin-bottom: 30px;
`
const Title = styled(Text)`
  flex: 1;
  text-align: center;
  ${(props) => props.theme.fonts.Headline};
`
const IconContainer = styled(TouchableOpacity)`
  flex: 1;
`
const Reset = styled(Text)`
  flex: 1;
  text-align: right;
  ${(props) => props.theme.fonts.Body};
  color: ${(props) => props.theme.colors.primary};
`

export default ModalHeader
